import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSalaryStore } from "../../store/useSalaryStore";
import { useCandidateProfileStore } from "../../store/useCandidateProfileStore";

export default function EditSalaryForm({ onClose, setSalary, defaultData }: any) {
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";
  const info = defaultData?.[0] ?? {};

  const [form, setForm] = useState({
    currentSalary: info.currentSalary ?? "",
    expectedSalary: info.expectedSalary ?? "",
    currentSalaryMethod: info.currentSalaryMethod ?? "gross",
    expectedSalaryMethod: info.expectedSalaryMethod ?? "gross",
    negotiable: info.negotiable ?? false,
  });

  const formatNumber = (num: string) =>
    num ? new Intl.NumberFormat("id-ID").format(Number(num)) : "";

  const handleChange = (e: any) => {
    const raw = e.target.value.replace(/\D/g, "");
    setForm({ ...form, [e.target.name]: raw });
  };

  const handleSelectChange = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e: any) => {
    setForm({ ...form, negotiable: e.target.checked });
  };

  const { updateSalary, loading } = useSalaryStore();
  const { fetchCandidateProfile } = useCandidateProfileStore();

  const handleSave = async () => {
    const success = await updateSalary({
      currentSalary: form.currentSalary,
      expectedSalary: form.expectedSalary,
      currentSalaryMethod: form.currentSalaryMethod,
      expectedSalaryMethod: form.expectedSalaryMethod,
      negotiable: form.negotiable,
    });

    if (success) {
      fetchCandidateProfile();
      setSalary([
        {
          currentSalary: form.currentSalary,
          expectedSalary: form.expectedSalary,
          currentSalaryMethod: form.currentSalaryMethod,
          expectedSalaryMethod: form.expectedSalaryMethod,
          negotiable: form.negotiable,
        },
      ]);
      onClose();
    }
  };


  return (
    <div className="space-y-6">
      {/* CURRENT SALARY */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium">
            {lang === "id" ? "Gaji Saat Ini" : "Current Salary"}
          </label>
          <input
            name="currentSalary"
            value={formatNumber(form.currentSalary)}
            onChange={handleChange}
            className="w-full border rounded-lg p-3"
          />
        </div>

        <div>
          <label className="text-sm font-medium">
            {lang === "id" ? "Metode Gaji Saat Ini" : "Current Salary Method"}
          </label>
          <select
            name="currentSalaryMethod"
            value={form.currentSalaryMethod}
            onChange={handleSelectChange}
            className="w-full border rounded-lg p-3"
          >
            <option value="gross">Gross</option>
            <option value="nett">Nett</option>
          </select>
        </div>
      </div>

      {/* EXPECTED SALARY */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium">
            {lang === "id" ? "Gaji Diharapkan" : "Expected Salary"}
          </label>
          <input
            name="expectedSalary"
            value={formatNumber(form.expectedSalary)}
            onChange={handleChange}
            className="w-full border rounded-lg p-3"
          />
        </div>

        <div>
          <label className="text-sm font-medium">
            {lang === "id" ? "Metode Gaji Diharapkan" : "Expected Salary Method"}
          </label>
          <select
            name="expectedSalaryMethod"
            value={form.expectedSalaryMethod}
            onChange={handleSelectChange}
            className="w-full border rounded-lg p-3"
          >
            <option value="gross">Gross</option>
            <option value="nett">Nett</option>
          </select>
        </div>
      </div>

      {/* NEGOTIABLE */}
      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          id="negotiable"
          checked={form.negotiable}
          onChange={handleCheckboxChange}
          className="w-4 h-4"
        />
        <label htmlFor="negotiable" className="text-sm font-medium">
          {lang === "id"
            ? "Gaji bisa dinegosiasikan"
            : "Salary is negotiable"}
        </label>
      </div>

      {/* ACTIONS */}
      <div className="flex justify-center gap-4 pt-2">
        <button
          onClick={onClose}
          className="px-6 py-3 rounded-lg border text-gray-500 font-semibold"
        >
          {lang === "id" ? "Batal" : "Cancel"}
        </button>
        <button
          onClick={handleSave}
          className="px-6 py-3 rounded-lg bg-primary text-white font-semibold"
        >
          {lang === "id" ? "Simpan" : "Save"}
        </button>
      </div>
    </div>
  );
}
